namespace GeniuzPOS.PosShift {
    export interface PsTaxInvoiceAddressRow {
        Id?: number;
        TaxInvName?: string;
        TaxInvAddressLine1?: string;
        TaxInvAddressLine2?: string;
        TaxInvAddressLine3?: string;
        TaxId?: string;
        TelNo?: string;
        MbId?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        LookupName?: string;
        CusTaxTypeFg?: number;
        TaxBranchName?: string;
        TaxBranchNo?: string;
        TaxPostalCode?: string;
        TaxCountryCode?: string;
        TaxEmail?: string;
    }

    export namespace PsTaxInvoiceAddressRow {
        export const idProperty = 'Id';
        export const nameProperty = 'LookupName';
        export const localTextPrefix = 'PosShift.PsTaxInvoiceAddress';
        export const lookupKey = 'PosShift.PsTaxInvoiceAddress';

        export function getLookup(): Q.Lookup<PsTaxInvoiceAddressRow> {
            return Q.getLookup<PsTaxInvoiceAddressRow>('PosShift.PsTaxInvoiceAddress');
        }
        export const deletePermission = '1POSBASE:ใบกำกับภาษี:ออกใบกำกับภาษี:Modify';
        export const insertPermission = '1POSBASE:ใบกำกับภาษี:ออกใบกำกับภาษี:Modify';
        export const readPermission = '*';
        export const updatePermission = '1POSBASE:ใบกำกับภาษี:ออกใบกำกับภาษี:Modify';

        export declare const enum Fields {
            Id = "Id",
            TaxInvName = "TaxInvName",
            TaxInvAddressLine1 = "TaxInvAddressLine1",
            TaxInvAddressLine2 = "TaxInvAddressLine2",
            TaxInvAddressLine3 = "TaxInvAddressLine3",
            TaxId = "TaxId",
            TelNo = "TelNo",
            MbId = "MbId",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            LookupName = "LookupName",
            CusTaxTypeFg = "CusTaxTypeFg",
            TaxBranchName = "TaxBranchName",
            TaxBranchNo = "TaxBranchNo",
            TaxPostalCode = "TaxPostalCode",
            TaxCountryCode = "TaxCountryCode",
            TaxEmail = "TaxEmail"
        }
    }
}
